import { render, staticRenderFns } from "./informersSection.vue?vue&type=template&id=29f3ca90&"
import script from "./informersSection.vue?vue&type=script&lang=js&"
export * from "./informersSection.vue?vue&type=script&lang=js&"
import style0 from "./style.module.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports